import { render, staticRenderFns } from "./RelatedProductRail.vue?vue&type=template&id=763ead17"
import script from "./RelatedProductRail.vue?vue&type=script&lang=js"
export * from "./RelatedProductRail.vue?vue&type=script&lang=js"
import style0 from "./RelatedProductRail.vue?vue&type=style&index=0&id=763ead17&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports